// Mirror of App\Enums\CommitteeFinancialFilter (campdraftone-api) — `is_financial` filter of
// /v2/committees. Keep in sync by hand. Labels stay here: it is a filter, not a stored column.
export const COMMITTEE_FINANCIAL_ALL = 'all'
export const COMMITTEE_FINANCIAL_FINANCIAL = 'financial'
export const COMMITTEE_FINANCIAL_UNFINANCIAL = 'unfinancial'

export const COMMITTEE_FINANCIAL_TABS = [
  { value: COMMITTEE_FINANCIAL_ALL, label: 'All' },
  { value: COMMITTEE_FINANCIAL_FINANCIAL, label: 'Financial' },
  { value: COMMITTEE_FINANCIAL_UNFINANCIAL, label: 'Unfinancial' }
]



// WEBPACK FOOTER //
// ./src/constants/committeeFinancialFilter.js